import { Button, ButtonProps } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';

interface LoginButtonProps extends ButtonProps {
  label: string;
}

export const LoginButton: React.FC<LoginButtonProps> = ({ label, ...props }) => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Button
      onClick={() => loginWithRedirect({
        appState: { returnTo: '/dashboard' }
      })}
      size="large"
      {...props}
    >
      {label}
    </Button>
  );
}; 